import {useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {selectAccessToken} from '@components/Login/userSlice';
import {selectVisibleDocuments} from '@components/SignerUi/signerUiSlice';
import {selectAuthRedirectUrl} from '@components/appSlice';
import useNextPendingDocumentId from '@components/SignerUi/hooks/useNextPendingDocumentId';
import {TRANSACTION_PATH, CEREMONY_PATH} from '@constants/routes';

const LEGACY_PATH_PREFIX = '/a';

/**
 * Strips legacy '/a' prefix from redirect paths.
 * Handles URLs like '/a/transaction/PKG/designer' → '/transaction/PKG/designer'
 */
function getCleanRedirectPath(path: string): string {
    if (path.startsWith(`${LEGACY_PATH_PREFIX}/`)) {
        return path.slice(LEGACY_PATH_PREFIX.length);
    }

    return path;
}

export default function AuthenticationPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const accessToken = useSelector(selectAccessToken);
    const documents = useSelector(selectVisibleDocuments);
    const authRedirectUrl = useSelector(selectAuthRedirectUrl);
    const nextPendingDocumentId = useNextPendingDocumentId();

    useEffect(() => {
        if (authRedirectUrl) {
            const redirectPath = getCleanRedirectPath(authRedirectUrl);
            navigate(redirectPath, {replace: true});
            return;
        }

        const transactionId = searchParams.get('transaction');

        if (!accessToken || !transactionId) {
            return;
        }

        if (!documents || documents.length === 0 || !nextPendingDocumentId) {
            return;
        }

        const ceremonyUrl = `${TRANSACTION_PATH}/${transactionId}${CEREMONY_PATH}`;
        navigate(ceremonyUrl, {replace: true});
    }, [authRedirectUrl, accessToken, navigate, searchParams, documents, nextPendingDocumentId]);

    return null;
}
